import React, { useState } from 'react'
import AppBar from '@material-ui/core/AppBar'
import { Tabs, Tab, Box } from '@material-ui/core'
import renderHelpAdminCupos, { renderHelpAdminCereales, renderHelpPenalizacion } from '../../constantes/constantesAyuda'

function TabPanel (props) {
  const { children, value, index } = props
  return (
    <div role='tabpanel' hidden={value !== index} id={index} key={index}>
      {value === index && (
        <Box style={{ textAlign: 'justify', margin: '5% 3%' }}>{children}</Box>
      )}
    </div>
  )
}

function AyudaContenido () {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const data = [
    {
      tabLabel: 'Administración de cupos',
      descripcion: renderHelpAdminCupos()
    },
    {
      tabLabel: 'Ingreso de camiones',
      descripcion: renderHelpAdminCereales()
    },
    {
      tabLabel: 'Penalización de camiones',
      descripcion: renderHelpPenalizacion()
    },
    {
      tabLabel: 'Buques anunciados',
      descripcion: renderHelpAdminCupos()
    },
    {
      tabLabel: 'Pesado bruto',
      descripcion: renderHelpAdminCupos()
    },
    {
      tabLabel: 'Consulta estado CTG',
      descripcion: renderHelpAdminCupos()
    }
  ]

  const renderLabel = () => {
    return data.map((d, index) => {
      return (
        <Tab key={index} label={d.tabLabel} style={{ outline: 'none' }} />
      )
    })
  }

  const renderInfo = () => {
    return data.map((d, index) => {
      return (
        <TabPanel value={value} index={index} key={index}>
          {d.descripcion}
        </TabPanel>
      )
    })
  }

  return (
    <>
      <AppBar position='static' color='default' key={'appbar'}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor='primary'
          variant='scrollable'
          scrollButtons='desktop'
        >
          {renderLabel()}
        </Tabs>
      </AppBar>
      {renderInfo()}
    </>
  )
}

export default AyudaContenido
